<template>
  <div>
    <div id="payButton" class="w-full h-[3rem] relative">
        <div class="w-1/3 h-full absolute left-0 rounded-l-md overflow-hidden">
            <button class="w-full h-full" type="button">
                <img class="w-full h-full object-cover object-center" src="/images/OMMOMO.webp" alt="" srcset="">
            </button>
        </div>
        <div class="w-2/3 h-full absolute right-0">
            <button type="button"  class="w-full text-white h-full items-center text-center rounded-r-md  text-xl bg-[#FF0000] ">
                <div class="w-1/2 flex items-center justify-center mx-auto space-x-1">
                    <img class="w-8" src="/icons/coins.png" alt="" srcset="">
                    <p class="text-center">{{ $t('payer') }}</p>
                </div>
            </button>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['montant'],
    data(){
        return{
            value:'',
            user:'',
            wallet:'',
        }
    },
    watch:{
        propsWatch: {
            handler(newValue) {
                this.value = newValue
                window.campay.options({
                    payButtonId: "payButton", //Required
                    description: `${this.$i18n.messages[`${localStorage.getItem('langue')}`].depotmel}`, //Required
                    amount: `${Math.floor(newValue)}`, //Optional
                    currency: "XAF", //Required
                    externalReference: "", //Optional
                    redirectUrl: "", //Optional
                });
            },
            deep: true
        },
    },
    mounted(){ 
        this.wallet = this.$store.state.wallet
        this.user = this.requestAccueil[0] 
        const script = document.createElement("script");
        script.src ="https://www.campay.net/sdk/js?app-id=miJJ1eQn_Bt28M_Cmpxqxr81LmlGUf3yElcVymNv98B8CDW6EbnnnsI_HGeXxTMBzSLMvytPpdmuK-3eQSrejA";
        script.addEventListener("load", 
        ()=>{
            window.campay.onSuccess = async (data) => { 
            // console.log(data)
                this.tokenCampay(data)
            }
                                                                            
            window.campay.onFail = async (data) =>{ 
                //alert('Status: '+data.status+'\n reference: '+data.reference) 
                alert(this.$i18n.messages[`${localStorage.getItem('langue')}`].echeccampay + '\n Status: '+data.status + '\n reference: '+data.reference) 
            } 
        });
        document.body.appendChild(script);                                                    
        
    },
    methods:{
        tokenCampay(dataPaiement){
            this.axios.post('https://campay.net/api/token/', {
                username:'Vevan7hrLxEeUFEvC4wVseS7O8Z8XMto97VlotL5hBLKBEKuxKncT0bBfqs_y9QyvxEFIPP_ZfWI-wQeQewljw',
                password:'J9_5KiJLgoO1KP5dA3zchP2uJIRhpF-AASCJlchnRXriV5To8yDtFxeVaMXdvt7G_5HSIXbQXQPDR_5Ub9C_Vg'
            },{
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            .then(({data}) => {
                this.SaveCredit(dataPaiement, data)
            })
            .catch()
        },
        SaveCredit(dataPaiement, dataTotken){
            this.axios.post(this.requestHttp + 'save-depot', {libelle: this.$crypto(JSON.stringify(['Dépôt d\'argent sur votre compte', 'Deposit money into your account'])),montant: this.$crypto(this.value), walletId: this.$crypto(this.wallet.id), rfc: this.$crypto(JSON.stringify(dataPaiement)), t_k: this.$crypto(JSON.stringify(dataTotken))},{
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
                },
            })
            .then(({data}) => {
                if(this.$store.state.alltransaction.length > 0){
                    this.$store.state.alltransaction.unshift(data[0])
                }
                if(this.$store.state.allCredit.length > 0){
                    this.$store.state.allCredit.unshift(data[0])
                }
                this.wallet.montant += this.value
                window.emitter.emit("alertSucces", ['Credit reussi', this.$i18n.messages[`${localStorage.getItem('langue')}`].creditsuccess])
                let modal = window.document.querySelector("#myCamPayModal .campay-modal-close")
                modal.click()
                window.emitter.emit("CloseModalPaiement", false)
            })
            .catch()
        }
    },
    computed:{
        requestHttp(){
            return this.$store.state.api
        },
        propsWatch(props){
            return props.montant
        },
        requestAccueil(){
            return this.$store.state.dataAccueil
        },
    }
}
</script>

<style>

</style>